/** SHA-256 hex of a file — ConfirmUpload requires the client-supplied digest. */
export async function sha256Hex(data) {
    const digest = await crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(digest))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
}
//# sourceMappingURL=upload.js.map